/**Excel Export Templates */
export enum Templates {
  AUDIT = 'audit',
  RECOMMENDATON = 'recommendation'
}
